"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("../index");
const Popover_1 = __importDefault(require("@mui/material/Popover"));
const icons_1 = require("../../icons");
const react_1 = __importDefault(require("react")); // peer dependency for component - dependency in root
const Popover = ({ children, boxProps, ...rest }) => (react_1.default.createElement(Popover_1.default, { ...rest },
    react_1.default.createElement(index_1.Box, { width: 260, ...boxProps },
        react_1.default.createElement(index_1.Box, { position: "absolute", top: 8, right: 4 },
            react_1.default.createElement(index_1.IconButton, { onClick: () => rest.onClose() },
                react_1.default.createElement(icons_1.Close, null))),
        children)));
exports.default = Popover;
